import React from 'react'
import PropTypes from 'prop-types'
import { Positioning } from 'LiveBoard/components/shared/Positioning'
import { LeadingItem } from 'LiveBoard/components/desktop/LeadingItem'
import PositionRenderer from 'LiveBoard/components/shared/PositionRenderer'
import ItemsContainer from 'LiveBoard/containers/ItemsContainer'
import { LAYOUT_POSITION } from 'shared/constants'

import './style.css.scss'

const BoardContent = ({
  board,
  campaign: {
    themeColorHex,
    items: {
      show: showItems,
      category_theme: categoryTheme,
      title: positioningText,
      show_item_description: showItemDescription
    },
    banner
  },
  promotion: {
    items: promotion,
    show: showPromotion
  },
  sideBySide,
  onCategoryChange,
  selectedCategoryId,
  leadingItem,
  hasLeadingItem,
  leadingItemAvailable,
  onItemClick,
  children
}) => {
  const bannerHeightClass = `${banner.height}-banner`

  return (
    <section className="board-content-container">
      <div className={`board-content ${bannerHeightClass}`}>
        <PositionRenderer
          sideBySide={sideBySide}
          promotion={promotion}
          location={LAYOUT_POSITION.belowBanner}
          themeColorHex={themeColorHex}
          onItemClick={onItemClick}
          isMobile={false}
          showPromotion={showPromotion} />
        { showItems &&
          <Positioning
            config={{ ...positioningText }}
            board={board}
            themeColorHex={themeColorHex}
            hasLeadingItem={hasLeadingItem}
            leadingItem={leadingItem}
            leadingItemAvailable={leadingItemAvailable}
            showItemDescription={showItemDescription}
            leadingItemComponent={LeadingItem}
            onItemClick={onItemClick} />
        }
        <ItemsContainer
          categoryTheme={categoryTheme}
          onCategoryChange={onCategoryChange}
          showItemDescription={showItemDescription}
          onItemClick={onItemClick}>
          {children}
        </ItemsContainer>
        <PositionRenderer
          sideBySide={sideBySide}
          promotion={promotion}
          location={LAYOUT_POSITION.aboveFooter}
          themeColorHex={themeColorHex}
          onItemClick={onItemClick}
          isMobile={false}
          showPromotion={showPromotion} />
      </div>
    </section>
  )
}

BoardContent.propTypes = {
  board: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  promotion: PropTypes.object.isRequired,
  sideBySide: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  selectedCategoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  leadingItem: PropTypes.object,
  hasLeadingItem: PropTypes.bool.isRequired,
  leadingItemAvailable: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired
}

export default BoardContent
